import { AES, SHA512 } from "crypto-js";
import JSEncrypt from "jsencrypt";

export async function login(credentials) {
  try {
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/authenticate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: credentials,
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      localStorage.setItem("token", content.token);
      return {
        data: content,
        success: true,
        message: "User logged in successfully",
      };
    } else {
      return {
        data: content.errorMessage,
        success: false,
        message: content.message,
      };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Unable to connect to the backend. Please try again later!",
    };
  }
}

export async function changePassword(obj) {
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/change-password`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: obj,
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return {
        data: content,
        success: true,
        message: "Password changed successfully",
      };
    } else {
      return { data: undefined, success: false, message: content.errorMessage };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Something went wrong !",
    };
  }
}

export async function forgotPassword(username) {
  try {
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/forgot-password`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: username,
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { data: content, success: true, message: content.message };
    } else {
      return { data: undefined, success: false, message: content.errorMessage };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Something went wrong !",
    };
  }
}

export async function resetPassword(data) {
  try {
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/reset-password`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: data,
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { data: content, success: true, message: content.message };
    } else {
      return { data: undefined, success: false, message: content.errorMessage };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Something went wrong !",
    };
  }
}

export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

export const generateSHA512Hash = (data) => {
  const hash = SHA512(data);
  const hashResult = hash.toString();
  return hashResult;
};

export const encryptInES6 = (data) => {
  return AES.encrypt(data, process.env.REACT_APP_KEY).toString();
};

export const encryptInRSA = (data) => {
  const RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(process.env.REACT_APP_PUBLIC_KEY);
  return RSAEncrypt.encrypt(data);
};
export async function validate() {
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(process.env.REACT_APP_API + `/validate`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    
    if (rawResponse.status === 200) {
      const content = await rawResponse.json();
      localStorage.setItem("token", content.body.token);
      localStorage.setItem("userType", content.body?.userType);

      return {
        data: content.body,
        success: true,
        message: "User logged in successfully",
      };
    } 
    else if (rawResponse.status === 401 && localStorage.getItem("token")) {
      alert("Request timeout. Please login again.")
      window.location.href = "/#/login";
      return { data: "fds", success: false, message: "Invalid login" };
    }
    else {
      return { data: "fds", success: false, message: "Invalid login" };
    }
  } catch (e) {
    return {
      data: undefined,
      success: false,
      message: "Something went wrong !",
    };
  }
}

export async function forgotUsername(username) {
  try {
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/forgot-username`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: username,
      }
    );

    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return {
        data: content.body,
        success: true,
        message: content.message,
      };
    } else {
      return { data: "fds", success: false, message: "Invalid Details" };
    }
  } catch (e) {
    return {
      data: undefined,
      success: false,
      message: "Something went wrong !",
    };
  }
}
